// Icons for secondary type
export const SECONDARY_ICON_NAMES: string[] = [
  '3d-view',
  '5g-circle',
  '5g',
  'accessories',
  'active-corner',
  'alarm',
  'apps',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'attachment',
  'bag',
  'business',
  'calendar',
  'call-centre-operator',
  'call',
  'camera',
  'chat',
  'check-circle',
  'check',
  'checkout',
  'chevron-down-circle',
  'chevron-down',
  'chevron-left-circle',
  'chevron-left',
  'chevron-right-circle',
  'chevron-right',
  'chevron-up-circle',
  'chevron-up',
  'clock',
  'close-circle',
  'close',
  'coins',
  'community',
  'consumption',
  'copy',
  'credit-card',
  'credit-recharge',
  'data',
  'delete',
  'delivery',
  'device-error',
  'device-insurance',
  'device-refurb',
  'device-strikethrough',
  'device-success',
  'device',
  'discount-badge',
  'discount',
  'document-digital',
  'document-signed',
  'document',
  'download',
  'e-sim',
  'earth',
  'edit',
  'email',
  'euro-circle',
  'euro',
  'exclamation-circle',
  'exclamation-triangle',
  'facebook-logo',
  'folder',
  'gift',
  'green',
  'hand-touch',
  'hide',
  'home',
  'image-placeholder',
  'info-circle',
  'instagram-logo',
  'internet-package',
  'invoice',
  'laptop',
  'lightbulb',
  'linkedin-logo',
  'list-file',
  'list',
  'loading',
  'locked-error',
  'locked',
  'mask',
  'menu',
  'message',
  'microphone',
  'minus-circle',
  'minus',
  'more',
  'multi-sim',
  'music',
  'network-status',
  'notification',
  'o2-app-favicon',
  'o2-logo',
  'offers',
  'package',
  'password-change',
  'pause',
  'person',
  'phone',
  'placeholder',
  'play',
  'plus-circle',
  'plus',
  'ported-msisdn',
  'position',
  'printer',
  'qr-code',
  'question-circle',
  'queue',
  'radost-favicon',
  'recharge-internet',
  'recycle',
  'redo',
  'router',
  'search-document',
  'search',
  'service',
  'settings',
  'shield',
  'sim',
  'small-fee',
  'smart-device',
  'star',
  'store',
  'tablet',
  'tesco-mobile-favicon',
  'thumb-down',
  'thumb-up',
  'tiktok-logo',
  'track-order',
  'transfer',
  'tv',
  'twitter-x-logo',
  'undo',
  'unfold',
  'unlocked',
  'update-disabled',
  'update',
  'view',
  'voucher',
  'wallet',
  'wifi',
  'youtube-logo',
];

// Icons for solid type
export const SOLID_ICON_NAMES: string[] = [
  'check-circle',
  'chevron-down-circle',
  'chevron-left-circle',
  'chevron-right-circle',
  'chevron-up-circle',
  'close-circle',
  'discount-badge',
  'exclamation-circle',
  'exclamation-triangle',
  'facebook-logo',
  'info-circle',
  'instagram-logo',
  'linkedin-logo',
  'minus-circle',
  'o2-app-favicon',
  'plus-circle',
  'question-circle',
  'tiktok-logo',
  'twitter-logo',
  'twitter-x-logo',
  'youtube-logo',
];

